/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import moment from 'moment';
import { v1 as uuid } from 'uuid';
import { startOf, add } from 'react-big-calendar/lib/utils/dates';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { Tooltip, withStyles } from '@material-ui/core';
import { getMonth } from 'date-fns';
import { ButtonGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import SmartButton from '../../../shared/components/SmartButton';
import { TYPE_MODAL } from '../../../shared/utils/constants';

function createCalendar(currentDateValue) {
  let currentDate = currentDateValue;
  if (!currentDate) {
    currentDate = moment();
  } else {
    currentDate = moment(currentDate);
  }

  const first = currentDate.clone().startOf('month');
  const last = currentDate.clone().endOf('month');
  const weeksCount = 6;
  const calendar = Object.assign([], { currentDate, first, last });

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber += 1) {
    const week = [];
    calendar.push(week);
    calendar.year = currentDate.year();
    calendar.month = currentDate.month();

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day += 1) {
      const date = currentDate.clone().set('date', day + 1 - first.day());
      date.calendar = calendar;
      week.push(date);
    }
  }

  return calendar;
}

const EventsTooltip = withStyles(() => ({
  tooltip: {
    width: '16rem',
    backgroundColor: '#fff',
    border: '1px solid rgba(0,0,0,0.06)',
  },
  arrow: {
    color: '#fff',
    '&::before': {
      backgroundColor: '#fff',
      border: '1px solid rgba(0,0,0,0.06)',
    },
  },
}))(Tooltip);

function CalendarDate(props) {
  const { t, dateToRender, dateOfMonth, day, onRemoveEvent } = props;
  const today =
    dateToRender.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
      ? 'today'
      : '';

  if (dateToRender.month() < dateOfMonth.month()) {
    return (
      <button type="button" disabled className="date prev-month">
        {dateToRender.date()}
      </button>
    );
  }

  if (dateToRender.month() > dateOfMonth.month()) {
    return (
      <button type="button" disabled className="date next-month">
        {dateToRender.date()}
      </button>
    );
  }
  let backgroundColor1 = day && !day.workDay ? '#e7e7e7' : '#FFF';
  let backgroundColor2 = day && !day.workDay ? '#e7e7e7' : '#FFF';
  let isCalendarMarker = false;
  let markersArray;
  if (day && day.markers.length) {
    const { markers } = day;
    const markerCycles = markers.filter((item) => item.cycle);
    const markersBackground = markers.filter((item) => item.marker);
    markersArray = [...markers];
    if (markersArray.length) {
      isCalendarMarker = true;
      if (markersBackground.length) {
        if (markersBackground.length > 1) {
          backgroundColor1 = markersBackground[0].marker.color;
          backgroundColor2 = markersBackground[1].marker.color;
        } else {
          backgroundColor1 = markersBackground[0].marker.color;
          backgroundColor2 = markersBackground[0].marker.color;
        }
      }
    }

    if (markerCycles.length) {
      if (
        markerCycles[0].cycle.color &&
        (markerCycles[0].cycle.beginInMilli === day.dateInMilli ||
          markerCycles[0].cycle.endInMilli === day.dateInMilli)
      ) {
        backgroundColor1 = markerCycles[0].cycle.color;
        if (backgroundColor2 === '#e7e7e7' || backgroundColor2 === '#FFF') {
          backgroundColor2 = markerCycles[0].cycle.color;
        }
      }
    }
  }

  return (
    <>
      {day && isCalendarMarker ? (
        <EventsTooltip
          interactive
          arrow
          title={
            <>
              {markersArray.length
                ? markersArray.map((item) => (
                    <div className="container-identifier" key={uuid()}>
                      <button
                        type="button"
                        className="w-100 container-identifier-marker"
                        disabled={item.cycle}
                        onClick={() =>
                          props.onClick({
                            ...item,
                            marker: {
                              ...item.marker,
                              label: item.marker.name,
                              value: item.marker.id,
                            },
                            newMarker: false,
                            type: TYPE_MODAL.EVENT,
                            dateInMilli: new Date(
                              dateToRender.format()
                            ).getTime(),
                          })
                        }
                      >
                        {item.cycle ? (
                          <>
                            <span
                              style={{ background: '#BBDEFB' }}
                              className="color-identifier"
                            />
                            <span className="name-identifier">
                              {item.cycle.name}
                            </span>
                          </>
                        ) : (
                          <>
                            <span
                              style={{ background: item.marker.color }}
                              className="color-identifier"
                            />
                            <span className="name-identifier">
                              {item.marker.name}
                            </span>
                          </>
                        )}
                      </button>
                      {item.marker && (
                        <button
                          type="button"
                          onClick={() => onRemoveEvent({ ...day, ...item })}
                        >
                          <Icon path={mdiClose} size={0.8} color="#6A2B8B" />
                        </button>
                      )}
                    </div>
                  ))
                : null}
              <ButtonGroup className="btn-group--justified mt-2">
                <SmartButton
                  color="success"
                  label={t('general.new-m')}
                  onClick={() =>
                    props.onClick({
                      newMarker: true,
                      slot: new Date(dateToRender.format()),
                      type: TYPE_MODAL.EVENT,
                      ...day,
                    })
                  }
                />
              </ButtonGroup>
            </>
          }
        >
          <button
            type="button"
            style={{
              background: `linear-gradient(135deg, ${backgroundColor1} 50%, ${backgroundColor2} 50%)`,
            }}
            className={`date  ${today} ${
              day && !day.workDay ? 'unworked-day' : 'in-month'
            }`}
          >
            {dateToRender.date()}
          </button>
        </EventsTooltip>
      ) : (
        <button
          type="button"
          className={`date  ${today} ${
            day && !day.workDay ? 'unworked-day' : 'in-month'
          }`}
          style={{ background: backgroundColor1 }}
          onClick={() =>
            props.onClick({
              newMarker: true,
              slot: new Date(dateToRender.format()),
              type: TYPE_MODAL.EVENT,
              ...day,
            })
          }
        >
          {dateToRender.date()}
        </button>
      )}
    </>
  );
}

CalendarDate.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onRemoveEvent: PropTypes.func.isRequired,
  date: PropTypes.shape(PropTypes.shape),
  dateToRender: PropTypes.shape(PropTypes.shape).isRequired,
  dateOfMonth: PropTypes.shape(PropTypes.shape).isRequired,
  day: PropTypes.shape(PropTypes.shape),
};

CalendarDate.defaultProps = {
  date: {},
  day: null,
};

class Calendar extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onSelectSlot: PropTypes.func.isRequired,
    onRemoveEvent: PropTypes.func.isRequired,
    date: PropTypes.shape(PropTypes.shape),
    daysMonth: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  };

  static defaultProps = {
    date: {},
    daysMonth: null,
  };

  state = {
    calendar: undefined,
  };

  componentDidMount() {
    const { date } = this.props;
    this.setState({ calendar: createCalendar(date) });
  }

  componentDidUpdate(prevProps) {
    this.changeCreateCalendarState(prevProps);
  }

  changeCreateCalendarState(prevProps) {
    const { date } = this.props;
    if (date !== prevProps.date) {
      this.setState({ calendar: createCalendar(date) });
    }
  }

  render() {
    const { calendar } = this.state;

    if (!calendar) {
      return null;
    }
    const { t, onSelectSlot, daysMonth, onRemoveEvent } = this.props;

    return (
      <div className="month">
        <div className="bold-text">
          {calendar.currentDate.format('MMMM').toUpperCase()}
        </div>
        {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((day) => (
          <span key={uuid()} className="day">
            {day}
          </span>
        ))}
        {calendar.map((week) => (
          <div key={uuid()}>
            {week.map((date) => (
              <CalendarDate
                t={t}
                key={date.date()}
                dateToRender={date}
                dateOfMonth={calendar.currentDate}
                day={
                  daysMonth &&
                  daysMonth.length &&
                  daysMonth.find(
                    (day) =>
                      day.dateInMilli === new Date(date.format()).getTime()
                  )
                }
                onRemoveEvent={onRemoveEvent}
                onClick={(values) => onSelectSlot(values)}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }
}

class Year extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onSelectSlot: PropTypes.func.isRequired,
    onRemoveEvent: PropTypes.func.isRequired,
    date: PropTypes.shape(PropTypes.shape),
    daysCalendar: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
      .isRequired,
  };

  static defaultProps = {
    date: {},
  };

  render() {
    const { t, date, onSelectSlot, daysCalendar, onRemoveEvent } = this.props;
    const months = [];
    const firstMonth = startOf(date, 'year');
    const monthsArray = [];
    [...new Array(12)].forEach((item, index) => {
      let monthArray = [];
      daysCalendar.forEach((day) => {
        if (getMonth(new Date(day.dateInMilli)) === index) {
          monthArray = [...monthArray, day];
          monthsArray[index] = monthArray;
        }
      });
    });

    for (let i = 0; i < 12; i += 1) {
      months.push(
        <Calendar
          t={t}
          key={i + 1}
          date={add(firstMonth, i, 'month')}
          onSelectSlot={onSelectSlot}
          onRemoveEvent={onRemoveEvent}
          daysMonth={monthsArray[i]}
        />
      );
    }

    return <div className="year">{months.map((month) => month)}</div>;
  }
}

Year.range = (date) => {
  return [startOf(date, 'year')];
};

Year.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return add(date, -1, 'year');

    case navigate.NEXT:
      return add(date, 1, 'year');

    default:
      return date;
  }
};

Year.title = (date, { localizer }) =>
  localizer.format(date, 'yearHeaderFormat');

export default Year;
